export enum OptionsAmount {
	NO_OPTIONS, SINGLE_OPTION, SEVERAL_OPTIONS, MANY_OPTIONS
}
